'use strict';

$(() => {
  MPP.Modal.openOnClick(
    '.mpp-container .show-all-photos-holder',
    '#photo-tiled-layout-modal'
  ); // Photo Viewer

  let photoCarouselInit = false;
  const carouselModal = $('#photo-carousel-modal');
  const carousel = carouselModal.find('.jcarousel');
  const photosTiledLayout = $('#photos-tiled-layout');
  const carouselNext = carouselModal.find('.carousel-next');
  const carouselPrev = carouselModal.find('.carousel-previous');
  const currentPhotoIndexSpan = carouselModal.find('span.current-photo-index');
  const totalNumPhotosSpan = carouselModal.find('span.total-num-photos');
  const totalNumPhotos = parseInt(totalNumPhotosSpan.html());

  if (photosTiledLayout.length) {
    const thumbnails = photosTiledLayout.find('li');
    thumbnails.click(function() {
      const thumbnailIndex = parseInt($(this).data('index'));
      MPP.Modal.open('#photo-carousel-modal');

      if (!photoCarouselInit) {
        createPhotoCarousel();
        photoCarouselInit = true;
      }

      carousel.jcarousel('scroll', thumbnailIndex - 1, false);
      currentPhotoIndexSpan.html(thumbnailIndex);
      return decideArrowsAction(thumbnailIndex, totalNumPhotos);
    });
  }

  if (carousel.length) {
    $('li.photo-thumb').click(function() {
      if (!photoCarouselInit) {
        const carouselInstance = createPhotoCarousel();
        photoCarouselInit = true;
      }

      const index = parseInt($(this).data('index')); //# 0-based for transitions

      carousel.jcarousel('scroll', index - 1, false);
      currentPhotoIndexSpan.html(index);
      return decideArrowsAction(index, totalNumPhotos);
    });
  }

  function createPhotoCarousel() {
    carousel.jcarousel();
    carouselNext.click(() => {
      const currentIndex = carousel.jcarousel('visible').data('index');
      const newIndex = currentIndex + 1;

      if (currentIndex === totalNumPhotos) {
        return null;
      } //# 0-based for transitions

      return carousel.jcarousel('scroll', newIndex - 1, postAnimation);
    });
    carouselPrev.click(() => {
      const currentIndex = carousel.jcarousel('visible').data('index');
      const newIndex = currentIndex - 1;

      if (currentIndex === 1) {
        return null;
      } //# 0-based for transitions

      return carousel.jcarousel('scroll', newIndex - 1, postAnimation);
    });
    adjustItemsWidth();
    return $(window).resize(() => {
      if (!carouselModal.hasClass('show-modal')) {
        return null;
      }

      return adjustItemsWidth();
    });
  }

  function adjustItemsWidth() {
    const width = carousel.innerWidth();
    return carousel.find('li').css('width', `${width}px`);
  }

  function postAnimation() {
    const transitionedIndex = carousel.jcarousel('visible').data('index');
    currentPhotoIndexSpan.html(transitionedIndex);
    return decideArrowsAction(transitionedIndex, totalNumPhotos);
  }

  function decideArrowsAction(currentIndex, innerTotalNumPhotos) {
    if (currentIndex === 1) {
      carouselPrev.addClass('disabled');
    } else {
      carouselPrev.removeClass('disabled');
    }

    if (currentIndex === innerTotalNumPhotos) {
      return carouselNext.addClass('disabled');
    } else {
      return carouselNext.removeClass('disabled');
    }
  }

  function setImageMaxHeight() {
    // we set the height to the max possible, giving enough space for the modal title and margins
    const maxHeight = $(window).height() - 180;
    return carouselModal
      .find('.jcarousel ul li img')
      .css('max-height', maxHeight);
  }

  return $('body').on('modal-open:photo-carousel-modal', setImageMaxHeight);
});

function delayLoading() {
  $('img.img-load-delay').each(function() {
    const $imagex = $(this);
    const imgOriginal = $imagex.data('original');
    $imagex.attr('src', imgOriginal);
    return $imagex.addClass('loaded');
  });
  const heroImage = $('.merchant-hero-image').css('background-image');

  if (heroImage != null) {
    return $('.tour-img').css('background-image', heroImage);
  }
  return null;
} // Given that we're loading 900px+ images as 66px thumbnails without resizing, we're loading them after everything else is ready
// This is valid only for some images that are not in the Image Service

$(window).load(delayLoading);
